// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a53b6b53","644":"66e9caaf"}[chunkId] + ".chunk.js";
};